import React from 'react';

import './connected-logos.scss';
import type { ConnectedLogoItem } from './types';

interface ConnectedLogosProps {
  items: ConnectedLogoItem[];
  hideCheck?: boolean;
}

const CheckIcon = () => (
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.847656 4.66677L2.29687 6.99586C2.5456 7.39561 3.11387 7.43178 3.41127 7.06678L8.39516 0.950195"
      stroke="#1330BF"
      strokeWidth="1.37217"
      strokeLinecap="round"
    />
  </svg>
);

export function ConnectedLogos({ items, hideCheck = false }: ConnectedLogosProps) {
  return (
    <div className="presentation-layer connected-logos">
      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          <div className="connected-logos__card">{item.logo}</div>
          {index < items.length - 1 && (
            <div className="connected-logos__connector-container">
              {!hideCheck && (
                <div className="connected-logos__connector">
                  <CheckIcon />
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
